import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  home: [],
};

const slice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    loadReports(state, action) {
      state.home = action.payload;
    },
  },
});

export const { loadReports } = slice.actions;

export default slice.reducer;

// *****************************************************

export function getHomeReports() {
  return async dispatch => {
    try {
      const response = await axios.post('/api/status-sign-process');
      const { data } = response.data;
      dispatch(slice.actions.loadReports(data));
    } catch (e) {
      // Un 401/expiración de sesión no debe recargar la pestaña en bucle:
      // el interceptor de axios (src/utils/axios.js) ya refresca el token y, si
      // el refresh falla, limpia la sesión y los guards redirigen al login.
      // Solo se recarga ante errores reales del servidor (>= 500).
      const status = e?.response?.status;
      if (status && status >= 500) {
        window.location.reload();
      }
    }
  };
}
